export const getCookie = (cname) => {
  if (typeof window === 'undefined') return '';

  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  let found = ca.find((element) => element.startsWith(name) || element.startsWith(` ${name}`));
  if (found && found.length > 0) {
    found = found.trim().substring(name.length, found.length);
    if (found.startsWith('"')) found = found.substring(1);
    if (found.endsWith('"')) found = found.substring(0, found.length - 1);
    return found;
  }
  return '';
};

const cookieExists = (cookieName) => {
  const cookieValue = getCookie(cookieName) || '';
  return cookieValue.length > 0;
};

export const isLoggedIn = () => {
  if (typeof window === 'undefined') return null;

  if (window.THDCustomer) {
    const { isLoggedIn: loggedInStatus } = window.THDCustomer.default;
    return loggedInStatus;
  }
  return null;
};

export const isInternalUser = () => cookieExists('internalUser');

export const getAnalyticsAuthenticationStatus = () => {
  if (isInternalUser()) {
    return 'rep';
  }

  return isLoggedIn() ? 'consumer' : 'guest';
};

export const getLoggedInUserInfo = () => {
  if (typeof window === 'undefined') return {};

  if (window.THDCustomer) {
    const { email, svocID } = window.THDCustomer.default;
    return {
      identityId: svocID,
      email,
    };
  }
  return {};
};
